import { Messages } from '../../../../../utils/message-constants';
import Tooltip from '@mui/material/Tooltip';

export default function TooltipWithPermission({
  title,
  renderElement,
  hasPermission = true,
  permissionName,
}: {
  renderElement: (hasPermission: boolean) => React.ReactElement;
  title?: string;
  hasPermission?: boolean;
  permissionName: string;
}) {
  return (
    <Tooltip
      arrow
      title={
        hasPermission
          ? title ?? permissionName
          : Messages.Errors.Permission.Acting(permissionName)
      }
    >
      <span>{renderElement(hasPermission)}</span>
    </Tooltip>
  );
}
